export default "__VITE_ASSET__BrSG0meq__"